import { RestoMagWordmark } from "./RestoMagWordmark.tsx";

interface Props {
  logoUrl: string | null;
  name: string | null;
}

/**
 * Co-brand header (PRD §7, FR-2b): organizer logo flush-left, RestoMag flush-right,
 * on one row. Organizer logo falls back to its display name text; RestoMag is always
 * present. Logos cap at 32px tall so the partnership reads on narrow phones.
 */
export function CoBrandHeader({ logoUrl, name }: Props) {
  return (
    <header className="flex items-center justify-between gap-4 border-b border-neutral-200 bg-white px-4 py-3">
      <div className="flex min-w-0 items-center">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={name ? `${name} logo` : "Organizer logo"}
            className="h-8 max-h-8 w-auto object-contain"
            loading="eager"
          />
        ) : (
          <span className="truncate text-base font-semibold text-neutral-900">
            {name ?? "Event"}
          </span>
        )}
      </div>
      <div className="flex shrink-0 items-center">
        <RestoMagWordmark />
      </div>
    </header>
  );
}
